import { h } from 'preact';
import { useRef, useEffect } from 'preact/compat';

const useTimeout = (fn, duration) => {
  const timeoutInstance = useRef<ReturnType<typeof setTimeout>>();

  const clearTimeoutInstance = () => {
    clearTimeout(timeoutInstance.current);
  };

  useEffect(() => {
    return () => {
      clearTimeoutInstance();
    };
  }, []);

  const startTimeout = () => {
    timeoutInstance.current = setTimeout(fn, duration);
  };

  return [startTimeout, clearTimeoutInstance];
};

export default useTimeout;
